import AuthService from '../services/resource/authService';
import LocalStorageService from '../services/resource/localstorageService'
import { BASE_URL } from '../services/api';
import { createContext, useContext, useState, useEffect } from "react";

export const USER_LOGGED = '@BI:User'
export const TOKEN = '@BI:Token'
export const REFRESH_TOKEN = '@BI:RefreshToken'

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(() => {
        setAuthenticated(AuthService.isAuthenticated);
        return AuthService.getUser()
    });

    useEffect(() => {
        if (authenticated === false) {
            LocalStorageService.removeItem(USER_LOGGED);
            LocalStorageService.removeItem(TOKEN);
            LocalStorageService.removeItem(REFRESH_TOKEN);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const login = (user, token, refreshToken) => {
        LocalStorageService.addItem(USER_LOGGED, user)
        localStorage.setItem(TOKEN, token)
        if (refreshToken) localStorage.setItem(REFRESH_TOKEN, refreshToken)
        setUser(AuthService.getUser)
        localStorage.setItem("filialId", AuthService.getUser()?.filialId)
        setAuthenticated(true)
    }

    const logout = () => {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);
        setAuthenticated(false);
        AuthService.logout();
        localStorage.clear();
        setUser(null)

        // Revoga a sessão no servidor (best-effort — o logout local já aconteceu de qualquer
        // forma, então um erro aqui não deve travar nem avisar o usuário que está saindo).
        if (refreshToken) {
            fetch(`${BASE_URL}/api/usuarios/logout`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refreshToken }),
            }).catch(() => {});
        }
    }

    return (
        <AuthContext.Provider value={{ user, login, logout, authenticated }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error('Contexto não encontrado')
    }

    return context;
}